const axios = require('axios');

function saveToTxt(report,file_name,_this){
   axios.post('/tdlbuildermods',{prams:report,"file_name":file_name})
         .then((result)=>{
            // console.log(result);
   })
}

function saveJson(report,file_name){
   axios.post('/tdlbuildermods/json',{"report":report,"file_name":file_name})
   .then((res)=>{
      if(res.data.status == 200){
            console.log('successfully saved json');
      }
   })
}
function updateJson(report,id){
   axios.post(route('update_json'),{"report":report,"id":id})
   .then((res)=>{
      if(res.data.status == 200){
            console.log('successfully saved json');
      }
   })
}

export {saveToTxt,saveJson,updateJson}